import { useCallback, useEffect, useRef, useState } from "react";

// Router
import { useLocation, useNavigate } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  uploadFile,
} from "../../../redux/features/sharedResources/sharedResources";

// Utils
import ICONS from "../../../assets/Icons";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  ScreenSizeConfiguration,
} from "../../../utils/configurationProvider";

// Components
import AmountToWords from "../../../components/_utils/AmountToWords";
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../components/_utils/SVGComponent";

import "./index.css";
import FieldForceRequestAccount from "../../../components/FieldForceRequestTransactionComp/FieldForceRequestAccount";
import FieldForceRequestTxnAdditionalDetails from "../../../components/FieldForceRequestTransactionComp/FieldForceRequestTxnAdditionalDetails";
import FieldForceRequestTxnTransferAmount from "../../../components/FieldForceRequestTransactionComp/FieldForceRequestTxnTransferAmount";
import FieldForceRequestTxnConfirm from "../../../components/FieldForceRequestTransactionComp/FieldForceRequestTxnConfirm";
import { fieldForceTxnRequest } from "../../../redux/features/fieldForceTransaction";

const FieldForceRequestCreateTransactions = () => {
  //  useDispatch, useNavigate, useLocation
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  //  useRef
  const scrollIt = useRef(null);
  const openOwner = false;
  //  useState
  const [endDate, setEndDate] = useState({});
  const [quantity, setQuantity] = useState({});
  const [timeData, setTimeData] = useState({});
  const [startDate, setStartDate] = useState({});
  const [mapingCat, setMapingCat] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [hyperLinks, setHyperLinks] = useState({});
  const [quantities, setQuantities] = useState({});
  const [labelsAcc, setLabelsAcc] = useState(null);
  const [direction, setDirection] = useState(null);
  const [catSelect, setCatSelect] = useState(false);
  const [startDateCal, setStartDateCal] = useState({});
  const [showYearDrop, setShowYearDrop] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amountInWords, setAmountInWords] = useState("");
  const [selectedValue, setSelectedValue] = useState({});
  const [showDatePicker, setShowDatePicker] = useState({});
  const [additionalData, setAdditionalData] = useState({});
  const [removeClassName, setRemoveClassName] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [isSingleDateSelected, setIsSingleDateSelected] = useState(false);
  const [createActive, setCreateActive] = useState(false);
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountIFSC: "",
    bankAccountNo: "",
    categories: "",
    amount: "",
    settleType: "",
    bankLogo: "",
    pan: "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: GlobalConfiguration.lengthCheckZero,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountWords: "",
    expenseType: "",
    date: "",
    description: "",
    uploadFile: "",
    prevImage: [],
    labels: [],
    ownerLabels: [],
  });
  const [category, setCategory] = useState(
    txnPayLoad?.categories ? txnPayLoad?.categories?.split(",") : [],
  );

  //  useSelector
  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  //  Constants
  const steps = [
    "Destination account",
    "Category",
    "Amount",
    "Confirm and create",
  ];

  //  Callbacks

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  //  useEffect
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const handleKeyDown = useCallback((event) => {
    if (
      event.target.tagName !== "INPUT" &&
      event.target.tagName !== "TEXTAREA" &&
      (event.key === "ArrowLeft" || event.key === "ArrowRight")
    ) {
      event.preventDefault();
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  const formatDate = (date) => {
    return `${date.getDate()}/${date.getMonth() < GlobalConfiguration.panLength ? `0${date.getMonth() + GlobalConfiguration.lengthCheckOne}` : date.getMonth() + GlobalConfiguration.lengthCheckOne}/${date.getFullYear()}`;
  };

  const handleCreateTransaction = async () => {
    setCreateActive(true);

    let haveImage = txnPayLoad?.mergeCategory?.some((val) => {
      return val?.data_type === "upload" && val?.value !== "Not Given";
    });

    let storeData;

    let add = GlobalConfiguration.lengthCheckZero;

    // const fileUpload = await dispatch(uploadImages(txnPayLoad.uploadFile));
    // const fileUpload = await dispatch(
    //   uploadFile({ file: txnPayLoad.uploadFile }),
    // );
    if (haveImage) {
      const responseUpload = await Promise.all(
        Object.values(uploadedFiles).map((file) =>
          // dispatch(uploadImages(file)),
          dispatch(uploadFile({ file: file })),
        ),
      );
      if (responseUpload) {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];
            if (val?.data_type === "numeric") {
              const integerValue = parseInt(
                dataValue,
                GlobalConfiguration.panLength,
              );
              if (!isNaN(integerValue)) {
                return { ...val, value: integerValue };
              } else {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
                );
              }
            } else if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            } else if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            } else {
              return { ...val, value: dataValue };
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }
          return val;
        });
      }
    } else {
      storeData = selectedCategory?.configuration?.data?.map((val) => {
        if (additionalData[val?.name]) {
          const dataValue = additionalData[val?.name];
          if (val?.data_type === "numeric") {
            const integerValue = parseInt(
              dataValue,
              GlobalConfiguration.panLength,
            );
            if (!isNaN(integerValue)) {
              return { ...val, value: integerValue };
            } else {
              throw new Error(
                `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
              );
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest, value: dataValue };
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "toggle") {
          const { description, ...rest } = val;
          return { ...rest };
        }
        return val;
      });
    }

    const response1 = await dispatch(
      fieldForceTxnRequest({
        expense_type: txnPayLoad?.expenseType,
        amount: txnPayLoad.amount,
        field_force_account_id: txnPayLoad?.beneAccountId,
        // beneficiary_account_id: txnPayLoad.beneAccountId,
        // reimbursement_date: formatDate(new Date(txnPayLoad.date)),
        request_date: formatDate(new Date(txnPayLoad?.date)),
        // uploaded_file_data: fileUpload?.payload,
        category_id: selectedCategory?.id,
        additional_data: storeData,
        labels: [
          ...(txnPayLoad.labels || []),
          ...(txnPayLoad.ownerLabels || []),
        ],
        description: txnPayLoad?.description,

        // owner_account_id: txnPayLoad.ownerId,
      }),
    );

    if (response1?.error?.message !== "Rejected") {
      let transactionId = response1.payload?.request?.[0]?.request_id;

      setCreateActive(false);
      navigate(
        `/field_force_transaction_dashboard/create_field_force_request/success/${transactionId}`,
        {
          // replace: true,
        },
      );
    } else {
      navigate(
        "/field_force_transaction_dashboard/create_field_force_request/failed",
        {
          replace: true,
        },
      );

      setCreateActive(false);
    }
  };

  const handleNext = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckThree) {
      if (!createActive) {
        handleCreateTransaction();
      }
    } else {
      setActiveStep(
        (prevActiveStep) =>
          prevActiveStep + GlobalConfiguration?.lengthCheckOne,
      );

      setDirection("next");
      setRemoveClassName(false);

      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalMedium);

      setTimeout(() => {}, IntervalConfiguration?.intervalSmaller);
    }
  };

  const handleEnterKeyPress = useCallback(
    (e) => {
      if (e.key !== "Enter") return;

      e.preventDefault();
      e.stopPropagation();

      if (
        activeStep === GlobalConfiguration.lengthCheckZero &&
        !nextButtonEnabled
      ) {
        handleNext();
        return;
      } else if (
        activeStep === GlobalConfiguration.lengthCheckOne &&
        !nextButtonEnabled
      ) {
        handleNext();
        return;
      } else if (
        activeStep === GlobalConfiguration.lengthCheckTwo &&
        !nextButtonEnabled
      ) {
        handleNext();
        return;
      } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
        if (!createActive) {
          handleCreateTransaction();
        }
        return;
      }
    },
    [activeStep, handleNext, nextButtonEnabled, createActive],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [handleEnterKeyPress]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[0],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[1],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[2],
    },

    {
      previousText: "Previous",
      nextText: "Confirm",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--positive-act)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: createActive,
      nextLoaderNeeded: true,
      previousIsDisabled: createActive,
      nextIsEnabled: !nextButtonEnabled && !createActive,
      stepperText: steps[GlobalConfiguration.accountminLength],
    },
  ];

  const renderCreateTxn = () => {
    switch (activeStep) {
      case GlobalConfiguration?.lengthCheckZero:
        return (
          <FieldForceRequestAccount
            category={category}
            setCategory={setCategory}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            setAdditionalData={setAdditionalData}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            setSelectedValue={setSelectedValue}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setStartDateCal={setStartDateCal}
            setIsSingleDateSelected={setIsSingleDateSelected}
            setQuantities={setQuantities}
            setAmountInWords={setAmountInWords}
            setHyperLink={setHyperLinks}
            setPreviewImages={setPreviewImages}
            setUploadedFiles={setUploadedFiles}
            setTimeData={setTimeData}
            setLabelsAcc={setLabelsAcc}
          />
        );
      case GlobalConfiguration?.lengthCheckOne:
        return (
          <FieldForceRequestTxnAdditionalDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            categories={categories}
            category={category}
            setCategory={setCategory}
            catSelect={catSelect}
            setCatSelect={setCatSelect}
            mapingCat={mapingCat}
            setMapingCat={setMapingCat}
            handleCategorySelect={handleCategory}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            BenEnableNextButton={BenEnableNextButton}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setShowDatePicker={setShowDatePicker}
            startDateCal={startDateCal}
            setStartDateCal={setStartDateCal}
            isSingleDateSelected={isSingleDateSelected}
            setIsSingleDateSelected={setIsSingleDateSelected}
            quantities={quantities}
            setQuantities={setQuantities}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            setPreviewImages={setPreviewImages}
            timeData={timeData}
            setTimeData={setTimeData}
            setQuantity={setQuantity}
            quantity={quantity}
            setShowYearDrop={setShowYearDrop}
            showYearDrop={showYearDrop}
          />
        );
      case GlobalConfiguration?.lengthCheckTwo:
        return (
          <FieldForceRequestTxnTransferAmount
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
          />
        );
      case GlobalConfiguration?.lengthCheckThree:
        return (
          <FieldForceRequestTxnConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            previewImages={previewImages}
          />
        );
      default:
        return null;
    }
  };

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];

    const mandatoryFields = configData.filter((val) => val?.mandatory === "Y");
    const filledMandatoryFields = mergeCategory.filter(
      (val) =>
        val?.mandatory === "Y" &&
        (val?.data_type === "from_year_to_year"
          ? val?.value?.from && val?.value?.to
          : val?.value),
    );

    const isMandatoryFieldsFilled =
      mandatoryFields?.length === filledMandatoryFields?.length;

    const isHyperlinkHave = mergeCategory?.some(
      (val) => val?.data_type === "hyperlink",
    );

    const isHyperlinkvalid = mergeCategory
      ?.filter((val) => {
        return val?.data_type === "hyperlink" && val?.value !== "";
      })
      .every((val) => isValidHttpUrl(val?.value));

    const isHyperLink = isHyperlinkHave && isHyperlinkvalid;

    const isAmountValid =
      txnPayLoad?.amount > GlobalConfiguration?.lengthCheckZero;

    let isStepValid = false;

    switch (activeStep) {
      case GlobalConfiguration.lengthCheckZero:
        // isStepValid =
        //   !!txnPayLoad?.beneAccountId && !!txnPayLoad?.selectedCategory;
        isStepValid = !!txnPayLoad?.beneAccountId;
        break;

      case GlobalConfiguration.lengthCheckOne:
        isStepValid =
          isMandatoryFieldsFilled &&
          (!isHyperlinkHave || isHyperLink) &&
          !!txnPayLoad?.selectedCategory;
        break;

      case GlobalConfiguration.lengthCheckTwo:
        isStepValid = isAmountValid;
        break;

      case GlobalConfiguration.lengthCheckThree:
        isStepValid = true;
        break;

      default:
        isStepValid = false;
        break;
    }

    BenEnableNextButton(!isStepValid);
  }, [activeStep, txnPayLoad, hyperLinks]);

  const handleBack = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      navigate(-1);
    } else {
      setActiveStep((prevActiveStep) =>
        prevActiveStep
          ? prevActiveStep - GlobalConfiguration?.lengthCheckOne
          : GlobalConfiguration?.lengthCheckZero,
      );

      setDirection("previous");

      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration.intervalMedium);
      setTimeout(() => {}, errorcode.errorFailed);
    }
  };
  useEffect(() => {
    if (
      location?.state?.txnDetails?.reminderAmount !== "" &&
      txnPayLoad?.amount === "" &&
      location?.state !== null
    ) {
      let amountWords =
        AmountToWords(
          parseFloat(location?.state?.txnDetails?.reminderAmount),
        ) || "";
      setAmountInWords(
        location?.state?.txnDetails?.reminderAmount >=
          GlobalConfiguration.lengthCheckOne &&
          location?.state?.txnDetails?.reminderAmount <=
            GlobalConfiguration.accountnormalLength
          ? amountWords.replace("rupees", "rupee")
          : amountWords,
      );
      setTxnPayLoad((prev) => {
        return {
          ...prev,
          amount: location?.state?.txnDetails?.reminderAmount,
          amountWords:
            location?.state?.txnDetails?.reminderAmount >=
              GlobalConfiguration.lengthCheckOne &&
            location?.state?.txnDetails?.reminderAmount <=
              GlobalConfiguration.accountnormalLength
              ? amountWords.replace("rupees", "rupee")
              : amountWords,
        };
      });
    }
  }, [location]);
  const handleCategory = (selectedCategoryData) => {
    setSelectedCategory(selectedCategoryData);
  };

  const [isStepper, setIsStepper] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsStepper(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});

  return (
    <div
      className="w-width-full flex justify-start items-center flex-col bg-primary-bg overflow-y-auto"
      style={{
        height: openOwner ? "var(--height-full)" : "var(--full-height)",
      }}
    >
      <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
      <div className="bene_crt_reminder_header left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto  Qsmd:bg-transparent">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>

      {isStepper && (
        <>
          <div className="flex items-center w-full-width h-mobile-create-header bg-primary-nav p-padding-md top-top-base z-z-index-header shadow-box-shadow-bottom">
            <div
              className="cursor-pointer"
              onClick={() => {
                if (activeStep === GlobalConfiguration.lengthCheckZero) {
                  navigate("/field_force_transaction_dashboard");
                } else {
                  navigate(-1);
                }
              }}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                color={"var(--text-primary)"}
                height={"var(--icon-md)"}
                width={"var(--icon-md)"}
                alt="Arrow"
              />
            </div>
            <div className="flex flex-col ml-margin-md">
              <div className="text-text-primary text-base">
                Field force request
              </div>

              <>
                <div className="text-text-secondary text-xs">
                  {steps[activeStep] || ""}
                </div>
              </>
            </div>
          </div>
        </>
      )}

      <div className="overflow-y-auto overflow-x-hidden w-width-full h-height-full">
        <div
          className="max-w-tab-width-normal mx-auto overflow-hidden h-full flex flex-col items-center relative w-width-full"
          ref={scrollIt}
        >
          <>
            <div
              className={`w-width-full h-height-full overflow-y-auto no-scrollbar ${
                activeStep === GlobalConfiguration.lengthCheckZero &&
                direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClass
              }`}
            >
              {renderCreateTxn()}
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default FieldForceRequestCreateTransactions;
